export const SalesEmailAddress = 'sales@cerebrocapital.com';
export const CerebroPhoneNumber = '240-394-1311';
export const CerebroPhoneNumberHref = 'tel:2403941311';
export const LoanKickOffUrl = 'https://meetings.hubspot.com/lcampbell1/loan-request-kick-off';
export const LoanRequestUrl = 'https://meetings.hubspot.com/lcampbell1/loan-request-help';
export const EmptyGuid = '00000000-0000-0000-0000-000000000000';
export const MaxLenderCount = 2;
